import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { ssoSilent } from '../../api/session-api';

interface MsalAuthProps {
    children: JSX.Element;
}

const MsalAuth = ({ children }: MsalAuthProps) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        ssoSilent().then((result) => {
            setIsLoggedIn(result);
        });
    }, [useLocation().pathname]);

    return <>{isLoggedIn ? <>{children}</> : <></>}</>;
};

export default MsalAuth;
